"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = ButtonPill;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _buttonPill = _interopRequireDefault(require("./button-pill.css"));
function ButtonPill(_ref) {
  var className = _ref.className,
    theme = _ref.theme,
    label = _ref.label,
    testID = _ref['data-testid'],
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    "data-testid": testID,
    className: (0, _clsx["default"])(className, theme.grey, theme.colorDarkGrey, _buttonPill["default"].buttonPill),
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx["default"])(theme.mmcIconClose)
  }), " ", label);
}
ButtonPill.defaultProps = {
  label: 'Clear'
};